import React from "react";

export const Equalizer = ({ active = true, className = "" }) => (
  <div className={`eq ${className}`} data-testid="equalizer" aria-hidden={!active}>
    <span style={{ animationPlayState: active ? "running" : "paused" }} />
    <span style={{ animationPlayState: active ? "running" : "paused" }} />
    <span style={{ animationPlayState: active ? "running" : "paused" }} />
    <span style={{ animationPlayState: active ? "running" : "paused" }} />
    <span style={{ animationPlayState: active ? "running" : "paused" }} />
  </div>
);
